import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum CounterpartyDirectoryColumn {
    NAME = "name",
    ACCOUNTS = "accounts",
    SOURCE = "source",
    JOURNAL_ENTRIES = "journalEntries",
    DEBIT = "debit",
    CREDIT = "credit",
    /** Debit amount, relabelled "Amount" for single-direction contexts (e.g. the 1099 task) where a separate Credit column would always read empty. */
    AMOUNT = "amount",
    ELIGIBLE_1099 = "eligible1099",
    FEDERAL_TAX_CLASSIFICATION = "federalTaxClassification",
    BILLABLE_EXPENSES = "billableExpenses",
    INVOICES = "invoices",
    BILLS = "bills",
    ACTIONS = "actions",
}

const makeColumnSchema = (id: CounterpartyDirectoryColumn) =>
    ColumnSchema.extend({ id: z.literal(id) });

export const CounterpartyDirectoryViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.COUNTERPARTY_DIRECTORY),
    columns: z.array(
        z.discriminatedUnion("id", [
            makeColumnSchema(CounterpartyDirectoryColumn.NAME),
            makeColumnSchema(CounterpartyDirectoryColumn.ACCOUNTS),
            makeColumnSchema(CounterpartyDirectoryColumn.SOURCE),
            makeColumnSchema(CounterpartyDirectoryColumn.JOURNAL_ENTRIES),
            makeColumnSchema(CounterpartyDirectoryColumn.DEBIT),
            makeColumnSchema(CounterpartyDirectoryColumn.CREDIT),
            makeColumnSchema(CounterpartyDirectoryColumn.AMOUNT),
            makeColumnSchema(CounterpartyDirectoryColumn.ELIGIBLE_1099),
            makeColumnSchema(
                CounterpartyDirectoryColumn.FEDERAL_TAX_CLASSIFICATION,
            ),
            makeColumnSchema(CounterpartyDirectoryColumn.BILLABLE_EXPENSES),
            makeColumnSchema(CounterpartyDirectoryColumn.INVOICES),
            makeColumnSchema(CounterpartyDirectoryColumn.BILLS),
            makeColumnSchema(CounterpartyDirectoryColumn.ACTIONS),
        ]),
    ),
});

export type CounterpartyDirectoryView = z.infer<
    typeof CounterpartyDirectoryViewSchema
>;
